import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 2rem;
  gap: 3.2rem;
`;

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const GoalBox = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 0.8rem;
`;

export const GoalCard = styled.div`
  background-color: #24222a;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  color: #8e899f;
  border-radius: 0.8rem;
  p {
    text-align: center;
    font-size: 1.6rem;
    line-height: 2.1rem;
  }
  > :nth-child(2) {
    color: #fff;
  }
`;

export const IconTextBox = styled.div`
  display: flex;
  gap: 0.4rem;
  justify-content: center;
`;

export const UserInfoBox = styled.div`
  padding: 1.6rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  border-top: 1px solid #24222a;
  border-bottom: 1px solid #24222a;
  > div {
    display: flex;
    gap: 2.4rem;
    span {
      width: 8rem;
      color: #5c576b;
    }
    p {
      color: #c9c7d1;
    }
  }
`;
export const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;
`;

export const InputLabel = styled.label`
  color: #c9c7d1;
`;

export const TextArea = styled.textarea`
  background-color: #18171c;
  height: 16rem;
  padding: 1.6rem 1.6rem 0 1.6rem;
  border: 0.1rem solid #4d495a;
  border-radius: 0.8rem;
  margin-top: 0.8rem;
  ::placeholder {
    color: #5c576b;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2.1rem;
  }
`;

export const MaxLength = styled.div`
  position: absolute;
  color: #9170f2;
  right: 0;
  font-size: 1.2rem;
  line-height: 2.4rem;
`;

export const Title = styled.input`
  background-color: #18171c;
  height: 3rem;
  margin: 4rem 0 0.8rem 0;
  ::placeholder {
    color: #5c576b;
    font-size: 2.4rem;
    font-style: normal;
    font-weight: 700;
    line-height: 3rem;
  }
`;

export const MainPhotoBox = styled.div`
  width: 100%;
  background-color: #1f1e25;
  padding: 5.8rem 2rem;
  color: #5c576b;
  > div {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 12.4rem;
  }
`;

export const ButtonBox = styled.div`
  position: fixed;
  bottom: 0;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 50rem;
  padding: 2rem;
  display: flex;
  gap: 1.2rem;
`;

export const DataInputWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  .line {
    border: 0.1rem solid #24222a;
    margin: 0.8rem 0;
  }
`;

export const DataInputBox = styled.div`
  width: 100%;
  background-color: #1f1e25;
  display: flex;
  padding: 1.6rem;
  border-radius: 0.8rem;
  flex-direction: column;
  gap: 2rem;
`;

export const ToggleLabel = styled.p`
  width: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
`;

export const ToggleWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const Toggle = styled.div<{ isToggleOn: boolean }>`
  transition: all 0.3s;
  position: relative;
  width: 3.4rem;
  height: 2rem;
  border-radius: 1rem;
  padding: 0.2rem;
  ${props =>
    props.isToggleOn
      ? 'background-color: #7750E9'
      : 'background-color: #383441'};
`;

export const ToggleButton = styled.div<{ isToggleOn: boolean }>`
  transition: all 0.3s;
  display: block;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 1.6rem;
  background-color: ${props => (props.isToggleOn ? 'white' : '#5c576b')};
  transform: ${props =>
    props.isToggleOn ? 'translateX(1.4rem)' : 'translateX(0)'};
`;

export const ToggleBox = styled.div`
  background-color: #1f1e25;
  display: flex;
  gap: 1.2rem;
  svg {
    flex-shrink: 0;
  }
`;

export const FileInput = styled.input`
  display: none;
`;
